import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BookingMetadata} from '../../../types/booking-metadata';

interface Option {
  key: string;
  value: string;
}

@Component({
  selector: 'app-vd-radio',
  templateUrl: './vd-radio.component.html',
  styleUrls: ['./vd-radio.component.scss'],
})
export class VdRadioComponent implements OnInit {
  @Input() field: BookingMetadata;
  @Input() form: UntypedFormGroup;
  public options: Option[];

  public ngModelValue: string;

  constructor() {}

  ngOnInit(): void {
    this.options = this.field.options as Option[];
    this.ngModelValue = this.form.controls[this.field.key].value;
  }

  public changeValue(): void {
    this.form.controls[this.field.key].patchValue(this.ngModelValue);
  }

  public trackByMethod(i: number, el: Option) {
    return el ? el.key : null;
  }
}
